/* Customer Testimonials carousel — infinite loop version.
   Desktop (>= 750px): transform-based track with cloned card sets before/after
   the originals. The visible window always has cards on both sides, arrows
   never disable, and the index wraps seamlessly (invisible snap when crossing
   a full set boundary).
   Mobile (< 750px): native horizontal scroll with scroll-snap; arrows wrap
   from last card back to first (and vice versa). */
(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 750px)';

  function initCarousel(section) {
    var carousel = section.querySelector('.testimonials-carousel');
    var track = section.querySelector('.testimonials-track');
    if (!carousel || !track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.testimonial-card'));
    if (!cards.length) return;

    var prevBtn = section.querySelector('.testimonials-navigation .nav-button.prev');
    var nextBtn = section.querySelector('.testimonials-navigation .nav-button.next');
    var dots = Array.prototype.slice.call(section.querySelectorAll('.testimonials-dots .dot'));

    var mql = window.matchMedia(DESKTOP_MQ);
    var count = cards.length;
    // Logical index. Desktop: any integer (normalized lazily). Mobile: 0..count-1.
    var index = 0;
    var clones = [];
    var scrollRaf = null;

    function getGap() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap);
      return isNaN(gap) ? 20 : gap;
    }

    function getStep() {
      return cards[0].getBoundingClientRect().width + getGap();
    }

    function getSetWidth() {
      return getStep() * count;
    }

    function normIndex(i) {
      return ((i % count) + count) % count;
    }

    /* ---------- Clones (desktop infinite loop) ---------- */

    function removeClones() {
      clones.forEach(function (node) {
        if (node.parentNode) node.parentNode.removeChild(node);
      });
      clones = [];
    }

    function makeClone(card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      // Avoid duplicate ids / tab stops inside clones
      clone.removeAttribute('id');
      Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) {
        el.removeAttribute('id');
      });
      Array.prototype.forEach.call(
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]'),
        function (el) { el.setAttribute('tabindex', '-1'); }
      );
      return clone;
    }

    function buildClones() {
      removeClones();
      var viewport = carousel.clientWidth || window.innerWidth;
      var setWidth = getSetWidth();
      if (setWidth <= 0) return;
      // One full set before the originals (room to go prev), and enough sets
      // after to always cover the widest possible visible window.
      var setsAfter = Math.max(2, Math.ceil((viewport * 2) / setWidth) + 1);

      // Prepend one set (insert in reverse to keep card order)
      for (var i = count - 1; i >= 0; i--) {
        var before = makeClone(cards[i]);
        track.insertBefore(before, track.firstChild);
        clones.push(before);
      }
      // Append sets
      for (var s = 0; s < setsAfter; s++) {
        for (var j = 0; j < count; j++) {
          var after = makeClone(cards[j]);
          track.appendChild(after);
          clones.push(after);
        }
      }
    }

    /* ---------- Rendering ---------- */

    function updateDots() {
      var active = normIndex(index);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === active);
      });
      // Infinite loop: arrows never disable
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    function render(animate) {
      // One cloned set sits before the originals, so logical index i lives at
      // physical offset (i + count) * step.
      var offset = (index + count) * getStep();
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (!animate) {
        void track.offsetWidth; // force reflow so the jump isn't animated
        track.style.transition = '';
      }
      updateDots();
    }

    // Snap back into the canonical range without visual change.
    // Called before starting a new move, so no transitionend dependency
    // (also works when prefers-reduced-motion disables transitions).
    function normalize() {
      if (index >= count) {
        index -= count;
        render(false);
      } else if (index < 0) {
        index += count;
        render(false);
      }
    }

    /* ---------- Navigation ---------- */

    function goToMobile(target, smooth) {
      index = normIndex(target);
      var left = index * getStep();
      if (smooth === false) {
        track.scrollLeft = left;
      } else {
        track.scrollTo({ left: left, behavior: 'smooth' });
      }
      updateDots();
    }

    function move(delta) {
      if (mql.matches) {
        normalize();
        index += delta;
        render(true);
      } else {
        goToMobile(index + delta);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { move(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { move(1); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-slide'), 10);
        if (isNaN(target)) target = i;
        if (mql.matches) {
          normalize();
          index = target;
          render(true);
        } else {
          goToMobile(target);
        }
      });
    });

    // Keep dots in sync with native swipe scrolling on mobile
    track.addEventListener('scroll', function () {
      if (mql.matches) return;
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = null;
        var step = getStep();
        if (step > 0) {
          index = Math.max(0, Math.min(Math.round(track.scrollLeft / step), count - 1));
          updateDots();
        }
      });
    }, { passive: true });

    /* ---------- Mode switching / resize ---------- */

    function enterDesktop() {
      track.scrollLeft = 0;
      buildClones();
      index = normIndex(index);
      render(false);
    }

    function enterMobile() {
      removeClones();
      track.style.transition = 'none';
      track.style.transform = '';
      void track.offsetWidth;
      track.style.transition = '';
      goToMobile(index, false);
    }

    function onModeChange() {
      if (mql.matches) enterDesktop();
      else enterMobile();
    }

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onModeChange);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(onModeChange);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (mql.matches) {
          buildClones();
          index = normIndex(index);
          render(false);
        } else {
          goToMobile(index, false);
        }
      }, 150);
    });

    /* ---------- Init ---------- */

    if (mql.matches) enterDesktop();
    else goToMobile(0, false);
  }

  function init() {
    var sections = document.querySelectorAll('.testimonials-section');
    if (!sections.length) return;
    Array.prototype.forEach.call(sections, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
